module.exports = __webpack_public_path__ + "521105cc5da30380659313f2750020ab.svg";